import React from "react"
import { Parcelas } from '../../../../../../../types/consulta-acordo-interface'
import { useNeg } from '../../../../../../../context/NegContext'
import { useBoleto } from "../../../../../../../context/BoletoContext"

export interface ParcelasAcordoProps {
  parcelas: Parcelas[]
  dataAcordo: string
  formaPagamento: string
  codigoacordo: string;
}

export const ParcelasAcordo = ({ parcelas, dataAcordo, formaPagamento, codigoacordo }: ParcelasAcordoProps) => {
  const { parcelaAcordo, setParcelaAcordo } = useNeg()
  const { boleto } = useBoleto()

  function proximaParcela(nrpar: string) {
    const emAberto = parcelas.filter(item => item.status === 'EM ABERTO').sort((a, b) => Number(a?.nroparc) > Number(b?.nroparc) ? 1 : Number(a?.nroparc) < Number(b?.nroparc) ? -1 : 0)

    return emAberto[0]?.nroparc === nrpar
  }

  function getParcelas(p: Parcelas) {
    if (!boleto?.url) {
      if (parcelaAcordo?.id) {
        setParcelaAcordo({} as Parcelas)
      } else {
        setParcelaAcordo(p)
      }
    }
  }
  function parcStyle(isDisable: boolean) {
    return `td-parcelas ${isDisable && ' text-gray-400 '}`
  }


  return (
    <div className="my-2">
      <div className="overflow-x-hidden">
        <div className="inline-block w-full align-middle">
          <div className="max-h-[150px] overflow-hidden overflow-y-auto rounded-sm  border">
            <table className=" w-full  border-collapse divide-y divide-gray-200 ">
              <thead className="sticky top-0 bg-gray-200 ">
                <tr>
                  <th scope="col" className="th-parcelas">
                    {/* Checkbox */}
                  </th>

                  <th scope="col" className="th-parcelas">
                    Parcela
                  </th>
                  <th scope="col" className="th-parcelas">
                    Código acordo
                  </th>
                  <th scope="col" className="th-parcelas">
                    Data acordo
                  </th>
                  <th scope="col" className="th-parcelas">
                    Vencimento
                  </th>
                  <th scope="col" className="th-parcelas">
                    Valor a pagar
                  </th>
                  <th scope="col" className="th-parcelas">
                    Forma de pagamento
                  </th>
                  <th scope="col" className="th-parcelas">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {
                  parcelas && parcelas?.length > 0 && parcelas.map((p, i) => (
                    <tr key={p.id} className={`${!proximaParcela(p.nroparc) && '  pointer-events-none'}`}>
                      <td className="td-parcelas">
                        <input
                          type="checkbox"
                          className="h-3 w-3 rounded-sm accent-rose-600"
                          onChange={() => { getParcelas(p) }}
                          disabled={!proximaParcela(p?.nroparc)}
                          checked={p.id === parcelaAcordo.id ? true : false}
                        />
                      </td>
                      <td className={parcStyle(!proximaParcela(p.nroparc))}>
                        <span>{p?.nroparc}</span>
                      </td>
                      <td className={parcStyle(!proximaParcela(p.nroparc))}>
                        <span>{codigoacordo}</span>
                      </td>
                      <td className={parcStyle(!proximaParcela(p.nroparc))}>
                        <span>{dataAcordo}</span>
                      </td>
                      <td className={parcStyle(!proximaParcela(p.nroparc))}>
                        <span>{p.datvenci}</span>
                      </td>
                      <td className={parcStyle(!proximaParcela(p.nroparc))}>
                        <span>R$ {p.valprincipal}</span>
                      </td>
                      <td className={parcStyle(!proximaParcela(p.nroparc))}>
                        <span>{formaPagamento === '1' ? 'Boleto' : formaPagamento === '4' ? 'PIX' : 'Pgto em loja'}</span>
                      </td>
                      <td className={parcStyle(!proximaParcela(p.nroparc))}>
                        <div className=" flex items-center gap-2">
                          <span>{p.status}</span>
                          <div className={`h-2.5 w-2.5 rounded-full ${p.status === 'EM ABERTO' ? 'bg-red-500' : 'bg-green-500'}`}></div>
                        </div>

                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}